import { twMerge } from 'tailwind-merge';
import { formatPercentage } from '../../lib/formatters';
import { ColoredMetric } from '../ColoredMetric/ColoredMetric';

export const FundingRateBreakdown = ({
  fundingRateProjected1h,
  fundingRateProjected8h,
  fundingRateProjected1d,
  fundingRateProjected1y,
  className = '',
  valueClassName = '',
}: {
  fundingRateProjected1h: bigint | undefined;
  fundingRateProjected8h: bigint | undefined;
  fundingRateProjected1d: bigint | undefined;
  fundingRateProjected1y: bigint | undefined;
  className?: string;
  valueClassName?: string;
}) => {
  return (
    <div className={twMerge('flex flex-wrap gap-4 text-xs text-contentSecondary', className)}>
      <span className={valueClassName}>
        Hourly:{' '}
        <ColoredMetric
          value={fundingRateProjected1h}
          formatFn={(x) =>
            formatPercentage(x, { maximumFractionDigits: 4, minimumFractionDigits: 4 })
          }
        />
      </span>
      <span className={valueClassName}>
        8-Hour:{' '}
        <ColoredMetric
          value={fundingRateProjected8h}
          formatFn={(x) =>
            formatPercentage(x, { maximumFractionDigits: 4, minimumFractionDigits: 4 })
          }
        />
      </span>
      <span className={valueClassName}>
        Daily:{' '}
        <ColoredMetric
          value={fundingRateProjected1d}
          formatFn={(x) =>
            formatPercentage(x, { maximumFractionDigits: 4, minimumFractionDigits: 4 })
          }
        />
      </span>
      <span className={valueClassName}>
        Annualized: <ColoredMetric value={fundingRateProjected1y} formatFn={formatPercentage} />
      </span>
    </div>
  );
};
